<template>
  <button
    @click="handleClick"
    :class="buttonClass"
    :disabled="this.disabled">
    <span><slot/></span>
  </button>
</template>
<script>

export default {
  name: 'f-button',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'primary',
      validator: v => [
        'close',
        'danger',
        'dashboard',
        'dark',
        'go-back',
        'inverted',
        'inverted-danger',
        'inverted-light',
        'lnk-footer',
        'none',
        'outline',
        'primary',
        'primary-outline',
        'read-more',
        'sort-arrow',
        'text',
        'text-alert',
        'text-light',
        'warning'
      ].includes(v)
    },
    withArrow: {
      type: Boolean,
      default: false
    },
    withArrowBackwards: {
      type: Boolean,
      default: false
    },
    big: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSortAsc: false
    }
  },
  computed: {
    buttonClass () {
      let badgeCSSClass = ['f-btn'];

      if (this.theme) {
        badgeCSSClass.push(`f-btn-${this.theme}`);
      }

      if (this.withArrow || this.theme === 'read-more') {
        badgeCSSClass.push('f-btn-arrow');
      }

      if (this.withArrowBackwards) {
        badgeCSSClass.push('f-btn-arrow-backwards');
      }

      if (this.big) {
        badgeCSSClass.push('f-btn-big');
      }

      if (this.isSortAsc) {
        badgeCSSClass.push('f-btn-sort-arrow-asc');
      }

      return badgeCSSClass.join(' ');
    }
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e);

      if (this.theme === 'sort-arrow') {
        this.isSortAsc = !this.isSortAsc;
      }
    }
  }
}
</script>
